import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Sigup from '../components/Signup.vue'
import Login from '../components/Login.vue'
import Errorpage from '../components/Errorcomp.vue'
import Setup from '../components/Setup.vue'
import Dash from '../components/Dash.vue'
import RegularMail from '../components/Regular.vue'
import Cards from '../components/Cards.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
    {path:'/signup', component:Sigup, name:'signup'},
    {path:'/login', component:Login, name:'login'},
    {path:'/account/setup', component:Setup, name:'setup'},
    // for dashboard ... path#####
  {
    path:'/dash',
    component:Dash,
    name:'dash', children:[
      {path:'/card', component:Cards, name:'card'}, 
      // {path:'/', redirect},
      {path:'/regular', component:RegularMail, name:'regular'},
      // for regular route
      {path:'/regular/draft', component:()=>import('../components/box/Draft.vue'), name :'draft'},
      {path:'/member', component:()=>import('../components/box/Mailmethod.vue'), name:'methods'},
      {path:'/create_mail/:id', component:()=>import('../components/box/Methods.vue'), name:'create_mail'},
      {path:'/contact', component:()=>import('../components/Contacts.vue'), name:'contact'},
      {path:'/addfrom', component:()=>import('../components/box/Addfrom.vue'), name:'addfrom'}
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {path:"/:pathMatch(.*)*", component:Errorpage}
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
